export const Color = {
    cultured     : '#f8f8f8',
    lavender     : '#e9ebfc',
    lightskyblue : '#87cefa',
    steelblue    : '#007bff',
    warning      : '#ffc107',
    lightyellow  : '#ffffe0',
    platinum     : '#dee2e6',
    outerspace   : '#484848',
    darkgunmetal : '#292521'

};

